import { EyeIcon, Phone } from 'lucide-react';
import React from 'react';
import DataTable from 'react-data-table-component';

const customStyles = {
  header: {
    style: {
      minHeight: '56px',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#0D3B3F',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: 'rgba(255,255,255,0.1)',
      borderRadius: '1.5rem 1.5rem 0 0',
      marginBottom: '8px',
    },
  },
  headCells: {
    style: {
      color: '#EAB308',
      fontSize: '10px',
      fontWeight: '900',
      textTransform: 'uppercase',
      letterSpacing: '0.2em',
      paddingLeft: '24px',
    },
  },
  cells: {
    style: {
      fontSize: '13px',
      color: '#0D3B3F',
      paddingLeft: '24px',
      fontWeight: '600',
    },
  },
  rows: {
    style: {
      minHeight: '72px',
      borderRadius: '1rem',
      backgroundColor: 'white',
      marginBottom: '8px',
      border: '1px solid #F3F4F6',
      '&:hover': {
        backgroundColor: '#F9FAFB',
        transform: 'scale-[1.01]',
        boxShadow: '0 10px 30px rgba(0,0,0,0.02)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }
    },
  },
  pagination: {
    style: {
      border: 'none',
      fontSize: '11px',
      fontWeight: '800',
      color: '#0D3B3F',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      marginTop: '12px',
    },
  },
};

export default function UsersTable({ limit, users, onEdit }) {
  const columns = [
    {
      name: 'ID#',
      selector: (row, index) => index + 1,
      width: '80px',
      cell: (row, index) => (
        <span className="text-[10px] font-black text-premium-gold bg-premium-teal/5 px-2 py-1 rounded-lg">
          {String(index + 1).padStart(2, '0')}
        </span>
      )
    },
    {
      name: 'Full Name',
      selector: row => `${row.firstName} ${row.lastName}`,
      sortable: true,
      cell: row => (
        <div className="flex flex-col">
          <span className="font-black text-premium-teal tracking-tight">{row.firstName} {row.lastName}</span>
          <span className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">{row.username}</span>
        </div>
      )
    },
    {
      name: 'Telephone',
      selector: row => row.phone,
      cell: row => (
        <div className="flex items-center gap-2 text-gray-500">
          <Phone size={14} className="text-premium-gold/50" />
          <span className="font-mono text-xs">{row.phone}</span>
        </div>
      )
    },
    {
      name: 'UserType',
      selector: row => row.userType,
      sortable: true,
      cell: row => (
        <span className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest border ${row.userType === 'SUPER_ADMIN'
          ? 'bg-premium-gold/10 text-premium-gold border-premium-gold/20'
          : 'bg-premium-teal/10 text-premium-teal border-premium-teal/20'
          }`}>
          {row.userType}
        </span>
      )
    },
    {
      name: 'Actions',
      cell: row => (
        <button
          onClick={() => onEdit(row)}
          className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center text-premium-teal hover:bg-premium-teal hover:text-white transition-all transform hover:rotate-6 shadow-sm"
        >
          <EyeIcon size={18} />
        </button>
      ),
      width: '100px'
    },
  ];

  const displayedData = limit ? users.slice(0, limit) : users;

  return (
    <div className="animate-fade-in-up">
      <DataTable
        columns={columns}
        data={displayedData}
        pagination
        customStyles={customStyles}
        noHeader
      />
    </div>
  );
}
